import { useTypedQuery } from "hooks";
import { DevicesDashboardQueryKeys } from "modules/DevicesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components";

const formatOSVersions = (osVersions: string[]): DropdownItemProps<string>[] => osVersions.map(os => ({ key: os, value: os, text: os }));

export const useOsVersionsQuery = () =>
  useTypedQuery({
    queryKey: DevicesDashboardQueryKeys.osVersions,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.os_versions,
    select: formatOSVersions
  });
